// extracted by mini-css-extract-plugin
export var sliderRange = "_d2-2";
export var sliderRoot = "_d2-0";
export var sliderThumb = "_d2-3";
export var sliderTrack = "_d2-1";